/* @flow */
import React from 'react';
import BoxBody from 'components/BoxBody.jsx';
import DialogContent from 'components/DialogContent.jsx';
import BirthdateSelector from 'chat/components/BirthdateSelector.jsx';
import UserActions from 'user/UserActions';
import Button from 'components/Button.jsx';

import './styles/JoinInfoPageBirthdate.scss';

class JoinInfoPageBirthdate extends React.Component {
  props: {
    onDone: Function,
    onError: Function,
  }

  state: {
    birthdate: ?Date,
    errors: ?Object,
  }

  state = {
    birthdate: null,
    errors: null,
  }

  onBirthdateChange = (birthdate: ?Date) => {
    // $FlowFixMe
    this.setState({ birthdate });
  }

  canSubmit = () => {
    return !!this.state.birthdate;
  }

  submit = () => {
    const onError = response => {
      this.props.onError(response);

      const errors = {};

      if (response && response.code === 'validation_error') {
        for (const field of response['field_errors']) {
          errors[field['field_name']] = field.messages.join(', ');
        }
      }

      // $FlowFixMe
      this.setState({ errors });
    };

    UserActions
      .update({ birthdate: this.state.birthdate })
      .then(this.props.onDone, onError);
  }

  render() {
    return (
      <DialogContent
        size="small"
        full
        className="JoinInfoPageBirthdate"
        title={'What is your birthday?'}
        subtext={'No one else will see this information.'}>
        <BoxBody divided>

          <BirthdateSelector
            initialDate={this.state.birthdate}
            onChange={this.onBirthdateChange}
          />

          {
            this.state.errors && 'birthdate' in this.state.errors ?
              <span className="JoinInfoPageBirthdate-Error">
                {this.state.errors['birthdate']}
              </span>
            : null
          }

          <Button
            disabled={!this.canSubmit()}
            onClick={this.submit}>
            Save
          </Button>
        </BoxBody>
      </DialogContent>
    );
  }
}

export default JoinInfoPageBirthdate;



// WEBPACK FOOTER //
// ./src/join/components/JoinInfoPageBirthdate.jsx